import React from "react";
import styles from "./Home.module.css";
import HeroSection from "../components/HeroSection";
import ProjectsSection from "../components/ProjectsSection";
import Contact from "./Contact";
import AboutTextBlock from "../components/AboutTextBlock";
import WithSplashOnMediaLoad from "../components/WithSplashOnMediaLoad";

const heroPreloadSources = [
  "/media/video-light/posters/hero1.jpg",
  "/media/video-light/mp4/720/hero-720.mp4",
];

const Home: React.FC = () => {
  return (
    <WithSplashOnMediaLoad
      sources={heroPreloadSources}
      delay={1000}
      postDelay={1000}
      timeout={5000}
    >
      <main className={styles.homePage}>
        <HeroSection />
        <AboutTextBlock />
        <ProjectsSection />
        <Contact />
      </main>
    </WithSplashOnMediaLoad>
  );
};

export default Home;
